import React, { Component } from 'react';
import {
    TextField,
} from '@material-ui/core/';

import EnhancedTable from "@apricityhealth/web-common-lib/components/EnhancedTable";
import Condition from '@apricityhealth/web-common-lib/components/Condition';
export class PatientConditionsView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            conditions: props.conditions || [],
            filtered: [],
            dialog: null,
            progress: null,
            filter: ''
        }
    }

    componentDidMount() {
        this.applyFilter();
    }

    componentDidUpdate(prevProps) {
        if (this.props.conditions !== prevProps.conditions)
            this.applyFilter();
    }

    applyFilter() {
        let { filter, conditions } = this.state;
        let filtered = [];
        for (let i = 0; i < conditions.length; ++i) {
            const condition = conditions[i];
            if (filter) {
                if ( condition.conditionId.indexOf(filter.toLocaleLowerCase()) >= 0 ) {
                    filtered.push(condition);
                } else if (condition.ref) {
                    const { label } = condition.ref.state;
                    if ( label && label.toLowerCase().indexOf(filter.toLowerCase()) >= 0) {
                        filtered.push(condition);
                    }
                }
            } else {
                filtered.push(condition);
            }
        }
        this.setState({ filtered });
    }
    
    render() {
        const { planId, appContext } = this.props;
        const { dialog, filter, filtered } = this.state;
        const dataColumns = [
            { id: 'startDate', label: 'Start Date' },
            { id: 'endDate', label: 'End Date' },
            { id: 'stageDx', label: 'Stage' },
            { id: 'conditionId', label: 'Name', formatValue: (v, r) => {
                return <Condition appContext={appContext} planId={planId} conditionId={v} ref={(ref) => r.ref = ref} />;
            }},
            { id: 'text', label: 'Text' }
        ];

        let filterInput = <div >
            <TextField style={{ margin: 5, width: 500 }} value={filter} label="Filter"
                onChange={(e) => this.setState({ filter: e.target.value }, this.applyFilter.bind(this))} />
        </div>;
        return <table style={{ width: '100%' }}><tbody>
            <tr><td>
                {filterInput}
            </td><td align='right'>
                    {dialog}
                </td></tr>
            <tr><td colSpan={2}>
                <EnhancedTable
                    onTable={(table) => { this._types = table }}
                    order='desc'
                    orderBy='startDate'
                    columnData={dataColumns}
                    data={filtered}
                    rowsPerPage={25}
                    title='Conditions' />
            </td></tr>
        </tbody></table>;
    }
}

export default PatientConditionsView;
